export const sortArray = ( a, b ) => {
    if ( a.toLocaleLowerCase() < b.toLocaleLowerCase() ) { return -1; }
    if ( a.toLocaleLowerCase() > b.toLocaleLowerCase() ) { return 1; }
    return 0;
};
